// const path = "/v2/organization/writer";
/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  const path = `/v2/organization/admin/user`;
  return {
    async getAll() {
      return repository.get(path).then(data => {
        return Promise.resolve(data.data.object);
      });
    },
    async inviteUser({ email, permissions, message }) {
      return repository.post(`${path}`, {
        date: Date.now(),
        message: message,
        email: email,
        alert: false,
        permissions: permissions
      });
    },
    /**
     *
     * @param {Object} param0
     * @param {Array<String>} param0.ids List of IDS to edit
     * @param {Array<String>} param0.permissions List of roles ro add
     */
    editUsers({ ids, permissions } = {}) {
      return repository.put(path, {
        users: ids,
        permissions: permissions
      });
    },
    /**
     * Wrapper for editUsers
     */
    editUser({ id, permissions } = {}) {
      return this.editUsers({ ids: [id], permissions: permissions });
    },
    removeUsers({ ids } = {}) {
      if (!Array.isArray(ids)) {
        throw new Error("Invalid parameter. 'ids' must be Array.");
      }
      return repository
        .delete(path, {
          params: {
            ids: encodeURIComponent(
              JSON.stringify(JSON.parse(JSON.stringify(ids)))
            )
          }
        })
        .then(response => {
          return Promise.resolve(response.data.object);
        });
    },
    /**
     *
     * @param {Object} param0
     * @param {String} param0.id
     */
    async removeUser({ id }) {
      return this.removeUsers({ ids: [id] });
    }
  };
}
